module.exports = __webpack_public_path__ + "e3c1980424b2fd4e04459a2b9d240cc1.png";


//////////////////
// WEBPACK FOOTER
// ./images/slide3.png
// module id = 673
// module chunks = 0